export default __webpack_public_path__ + "static/media/presentation-project-feedback.2ebec696.png";